import { render, staticRenderFns } from "./quesOrder.vue?vue&type=template&id=2ba5ea10&"
import script from "./quesOrder.vue?vue&type=script&lang=js&"
export * from "./quesOrder.vue?vue&type=script&lang=js&"
import style0 from "./quesOrder.vue?vue&type=style&index=0&id=2ba5ea10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports